export const BUILDER_PAYMENT_SETTINGS_SAVED = 'builder-payment-settings-saved';
export const BUILDER_PAYMENT_PROVIDER_BLIP_CLICKED = 'builder-payment-provider-blip-clicked';
export const BUILDER_PAYMENT_PROVIDER_OWN_CLICKED = 'builder-payment-provider-own-clicked';
export const BUILDER_PAYMENT_TAB_CLICKED = 'builder-payment-tab-clicked';
export const BUILDER_PAYMENT_METHOD_ADDITIONAL_SELECTED = 'builder-payment-method-additional-selected';
export const BUILDER_PAYMENT_METHOD_SELECTED = 'builder-payment-method-selected';
export const BUILDER_PAYMENT_METHOD_ADDITIONAL_ENABLED = 'builder-payment-method-additional-enabled';
export const BUILDER_PAYMENT_PRODUCT_TYPE_SELECTED = 'builder-payment-product-type-selected';
